<template>
  <v-card v-if="current" class="pa-0 pa-md-6" elevation="0">
    <v-card-text class="py-5" ref="content">
      <div class="mb-4">
        <v-responsive :aspect-ratio="1">
          <v-card class="fill-height position-relative" outlined>
            <ProxyImage :src="current.image"/>
          </v-card>
        </v-responsive>
      </div>

      <div class="d-flex flex-column align-start fill-width">
        <div>{{ current.caption || 'No caption' }}</div>
      </div>

      <v-divider class="my-4 mb-8"></v-divider>

      <ValidationObserver ref="observer">
        <form>
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <v-text-field
              :disabled="adding"
              :error-messages="errors"
              dense
              label="Name"
              v-model="values.name"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="price" rules="required" v-slot="{ errors }">
            <v-text-field
              :disabled="adding"
              :error-messages="errors"
              dense
              label="Price"
              type="number"
              v-model="values.price"
            ></v-text-field>
          </ValidationProvider>
        </form>

        <div class="d-flex mt-6">
          <v-btn @click="createItem" class="flex-grow-1" color="primary" elevation="0" :loading="adding">
            Add to products
          </v-btn>
        </div>
      </ValidationObserver>
    </v-card-text>

    <v-snackbar :color="toast.color || ''" top v-model="toast.visible">
      {{ toast.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import ProxyImage from "@/components/ProxyImage";

export default {
  name: "WhatsappStatusDetails",
  components: { ProxyImage },
  props: {
    current: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      adding: false,
      values: {
        name: '',
        price: '',
      },
      toast: {
        visible: false,
        color: 'orange',
        message: ''
      }
    }
  },
  created() {
    this.values = {
      name: this.current.values.name ?? '',
      price: this.current.values.price ?? '',
    }
  },
  methods: {
    async createItem() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      this.adding = true;
      const payload = {
        name: this.values.name,
        price: this.values.price,
        primary_picture: this.current.image,
        secondary_picture: "",
        tertiary_picture: "",
        fourth_picture: "",
        fifth_picture: "",
        slug: this.$route.params.mid,
        caption: this.current.caption,
        sell_on_credit: "1"
      };
      const res = await this.$http.post('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/merchant/status/item', payload);
      if (res.data.status) {
        this.toast = {
          visible: true,
          color: 'green',
          message: 'Product added successfully'
        }
        this.visible = false;
        this.current = null;
      } else {
        this.toast = {
          visible: true,
          color: 'red',
          message: res.data.message || 'An error occurred, please try again'
        }
      }
      this.adding = false;
    }
  }
}
</script>
